import type { IJsonSchema, IJsonSchemaClauses, IJsonSchemaConsents, IProperty } from "types/jsonSchema";
import type { IElement, IFormInputs, IUiSchema } from "types/uiSchema";

const firstStepNameMap = {
    Greeting: "greeting",
    Clauses: "clauses",
    Consents: "consents",
    PersonalData2: "personalData",
    CvFile: "cvFile",
    LocationSingle: "locationSingle",
    LocationMulti: "locationMulti",
} as const;

export interface IFirstStepElements {
    greeting: IFormInputs | null;
    clauses: IFormInputs | null;
    consents: IFormInputs | null;
    personalData: IFormInputs | null;
    cvFile: IElement | null;
    locationSingle: IFormInputs | null;
    locationMulti: IFormInputs | null;
}

type FirstStepNameKeys = keyof typeof firstStepNameMap;

export type SecondStepType = IFormInputs[];

interface IExtractedElements {
    firstStep: IFirstStepElements;
    firstStepArray: IFormInputs[];
    secondStep: SecondStepType;
}

export const prepareElements = (elements: IElement[]): IFormInputs[] => {
    const preparedElements = elements.flatMap((el) => el?.elements || []);

    return preparedElements;
};

export const extractStepsElements = (uiSchema: IUiSchema | null | undefined): IExtractedElements => {
    const elements = prepareElements(uiSchema?.elements ?? []);

    // todo: to delete
    const firstStep: IFirstStepElements = {
        greeting: null,
        clauses: null,
        consents: null,
        personalData: null,
        cvFile: null,
        locationSingle: null,
        locationMulti: null,
    };

    const firstStepArray: IFormInputs[] = [];
    const secondStep: SecondStepType = [];

    elements?.forEach((el) => {
        const key = firstStepNameMap[el["x-control-name"] as FirstStepNameKeys];

        if (key) {
            Object.assign(firstStep, { [key]: el });
            firstStepArray.push(el);
        } else {
            secondStep.push(el);
        }
    });

    return { firstStep, firstStepArray, secondStep };
};

export const extractJsonSchemaSteps = (jsonSchema: IJsonSchema | null | undefined) => {
    const elements = jsonSchema?.properties ?? {};

    const firstStep: Record<string, IProperty | IJsonSchemaClauses | IJsonSchemaConsents | null> = {
        cvFiles: null,
        clauses: null,
        consents: null,
        email: null,
        firstName: null,
        lastName: null,
        phone: null,
        workLocation: null,
        workLocations: null,
    };

    const secondStep: Record<string, IProperty> = {};

    Object.entries(elements).forEach(([key, value]) => {
        const el = value;

        if (key in firstStep) {
            Object.assign(firstStep, { [key]: el });
        } else {
            Object.assign(secondStep, { [key]: el });
        }
    });

    return { firstStep, secondStep };
};

// this is not the same as numberOfSteps in extraData
export const numberOfSteps = (uiSchema: IUiSchema | null | undefined) => {
    const { secondStep } = extractStepsElements(uiSchema);
    return secondStep?.length > 0 ? 2 : 1;
};
